export const GET_BUGHERD_CONTEXT_REQUEST = 'GET_BUGHERD_CONTEXT_REQUEST';
export const GET_BUGHERD_BOARDS_REQUEST = 'GET_BUGHERD_BOARDS_REQUEST';
export const SYNC_BUGHERD_BOARD_REQUEST = 'SYNC_BUGHERD_BOARD_REQUEST';
export const DISCONNECT_BUGHERD_REQUEST = 'DISCONNECT_BUGHERD_REQUEST';

export const getBugherdContext = (projectId, callback) => ({
    type: GET_BUGHERD_CONTEXT_REQUEST,
    payload: { projectId, callback }
});

export const getBugherdBoards = (clientId, callback) => ({
    type: GET_BUGHERD_BOARDS_REQUEST,
    payload: { clientId, callback }
});

export const syncBugherdBoard = (projectId, callback) => ({
    type: SYNC_BUGHERD_BOARD_REQUEST,
    payload: { projectId, callback }
});

export const disconnectBugherd = (clientId, callback) => ({
    type: DISCONNECT_BUGHERD_REQUEST,
    payload: { clientId, callback }
});
